import EETermsTable from "@assets/events-awards/ee/img-ee-awards-terms-table.png";

/**
 * component to render in terms and conditions tab at How to Nominate page EE
 */
const TermsAndConditions = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 p-4 pb-5 font-public-sans"
      data-testid="terms-and-conditions-component"
    >
      <p className="leading-[1.4]">
        By submitting an application for the Emerging Enterprise Award 2023 (the
        &quot;Award&quot;), we hereby declare that we have read, understood and
        agree to abide by the terms & conditions as follows:-
      </p>

      <ul className="list-outside list-decimal pl-8 leading-[1.4]">
        <li>
          We permit and authorise The Business Times, OCBC, RSM, Mastercard,
          A*STAR, Enterprise Singapore, Paia Consulting, and Rajah & Tann Asia
          (the &quot;organisers/sponsors&quot;) to use and disclose all
          information, data and materials submitted in connection with us and
          the Awards, to contact us for the Award-related activities, conduct
          searches with any public registry or credit bureau, research and
          analysis which might involve third party researchers and the
          publication of a report by third parties.
        </li>
        <li>
          We agree and undertake to indemnify and hold the organisers /sponsors
          harmless against any claims, proceedings, damages, losses and costs
          (including legal fees on an indemnity basis) that may arise in
          connection with the breach of any terms, warranties and conditions
          herein or in the event that any representations and authorisation
          given in connection with the Awards are untrue or invalid.
        </li>
        <li>
          We agree that the organisers/sponsors shall not be liable for any
          damages, losses, costs, expenses, claims and liabilities (whether
          direct, indirect, special or consequential and whether foreseeable or
          not) arising out of or in connection with matters relating to the
          Awards.
        </li>
        <li>
          We agree upon the written request of the organisers/sponsors to
          provide clarification, supporting evidence and relevant company
          information should the organisers need to verify the data provided in
          the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award application.
        </li>
        <li>
          We represent and warrant that all information provided by us pursuant
          to this application is true, correct and accurate as of the date of
          submission of the application.
        </li>
        <li>
          We agree, upon the written request of the organisers/sponsors to
          provide our actual and projected financial figures.
        </li>
        <li>
          We agree to notify the organisers/sponsors in the event of any changes
          to our eligibility for the Emerging Enterprise Award or the Emerging
          Enterprise Sustainability Award.
        </li>
        <li>
          We agree that the judges&apos; decision on all aspects of the Awards
          including the shortlist, evaluation and the publication of the list of
          the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award Finalists will be final. The organisers/sponsors
          are not under any obligation whatsoever to provide any reason or
          explanation to us.
        </li>
        <li>
          We agree to notify the organiser/sponsor in the event that we, our
          parent company or any of our subsidiaries have applied for its shares
          to be listed for quotation on the official list of a securities
          exchange as defined in the Securities and Futures Act 2001 on or
          before the closing date of the application.
        </li>
        <li>
          We agree to provide details of any litigation cases against us and
          (where we are a company) our directors/shareholders/partners/sole
          proprietor in the run-up to the publication of the list of the Award
          Finalists.
        </li>
        <li>
          We agree to abide by the publicity schedules and guidelines stipulated
          by the organisers/sponsors in the run-up to and after the publication
          of the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award Finalists, and we further agree that the
          organisers/sponsors have the discretion to amend such publicity
          schedules without prior notice to us.
        </li>
        <li>
          We consent to the use by any organisers/sponsors of our information
          provided to the organisers/sponsors (including, without limitation,
          our name, logos, photos and/or video shoot) and media interview
          articles to be used in any publicity and/or advertising materials of
          any organiser/sponsor.
        </li>
        <li>
          We agree to provide any relevant information requested by the
          organisers/sponsors in relation to us for purposes of inclusion in the
          Emerging Enterprise Award or the Emerging Enterprise Sustainability
          Award media promotions, press releases and marketing collateral.
        </li>
        <li>
          We agree to abide by the rules/standards as may be determined by the
          organisers/sponsors regarding the usage of the Emerging Enterprise
          Award or the Emerging Enterprise Sustainability Award logo.
        </li>
        <li>
          We agree that should we not accept any prize offered under the Awards
          by an organiser/sponsor, we shall forfeit all other prizes offered by
          the remaining organisers/sponsors.
        </li>
        <li>
          We agree that the Awards may be revoked by the organisers/sponsors in
          the event that the organisers/sponsors are of the view that we are in
          breach of any of the terms and conditions of the relevant Award.
        </li>
        <li>
          We agree and acknowledge that if we win any Award:
          <ul className="list-outside list-[lower-alpha] pl-8">
            <li>
              the interest-free term loan to be received shall be subject to the
              following conditions:
              <ul className="list-outside list-[upper-roman] pl-8">
                <li>the term loan shall be an unsecured facility;</li>
                <li>
                  &quot;Emerging Enterprise Award&quot; and the &quot;Emerging
                  Enterprise Sustainability Award&quot;, or up to SGD 100,000
                  for the &quot;Most Promising Startup Emerging Enterprise
                  Award&quot; and the &quot;Most Promising Startup Emerging
                  Enterprise Sustainability Award&quot;, provided that if the
                  winner is incorporated in Malaysia, Indonesia and/or Hong
                  Kong, the term loan shall be disbursed in a local-currency
                  equivalent amount (the conversion to be determined by the Bank
                  in its sole and absolute discretion);
                </li>
                <li className="-ml-5 flex list-none items-center">
                  <span>III.</span>
                  <img src={EETermsTable} alt="EE awards terms table" />
                </li>
                <li value={4}>
                  the loan shall be interest free for 24 months from the date of
                  the loan disbursement;
                </li>
                <li>
                  no interest, processing and annual fees will be charged for 24
                  months from the date of loan disbursement.
                </li>
                <li>
                  disbursement of the term loan shall only be made into a
                  business account with OCBC (i.e. the winner of the relevant
                  Award must open an account with OCBC in order to receive the
                  term loan);
                </li>
                <li>
                  if the winner of the relevant Award is not incorporated in
                  Singapore, Malaysia, Indonesia and/or Hong Kong, they must
                  incorporate a subsidiary in Singapore to receive the term
                  loan; and
                </li>
                <li>
                  the terms set out above are not exhaustive and the full and
                  final terms of the term loan shall be subject to the final
                  letter of offer issued to us; and
                </li>
              </ul>
            </li>

            <li>
              the &quot;RSM Consulting Package for Growing Business&quot; (the
              &quot;Consulting Package&quot;) shall be subject to the following
              conditions:
              <ul className="list-outside list-[upper-roman] pl-8">
                <li>
                  the Consulting Package will only be provided to the winning
                  company and excludes any other company in its group of
                  companies, or its related companies;
                </li>
                <li>
                  redemption of the Consulting Package shall not be applicable
                  for the assurance, tax advisory and valuation advisory
                  services;
                </li>
                <li>
                  the Consulting Package is non transferable, not exchangeable
                  for cash and must be utilised within 6 months of the Award;
                  and
                </li>
                <li>
                  the final acceptance of any engagement by RSM pursuant to the
                  Consulting Package shall be subject to us complying with RSM’s
                  internal requirements on client acceptance procedures (as
                  prescribed by RSM).
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          These terms & conditions shall be governed by the laws of Singapore.
          The courts of Singapore shall have exclusive jurisdiction to settle
          any dispute, controversy or claim arising from or in connection with
          these terms & conditions and/or the Emerging Enterprise Award or the
          Emerging Enterprise Sustainability Award.
        </li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
